import React from 'react'
import styled from '@emotion/styled'
import { spacer } from 'stylist'
import ModalSection from 'components/ModalSection'
import Container from 'components/Container'
import PlainLink from 'components/PlainLink'
import { Bold, Bolder, Pewter } from 'components/Text'
import SummaryBox from 'routes/estimate/SummaryBox'
import Result from './Result'
import { redirectDone, sampleName } from 'utils'
import { postSample } from 'utils/api'
import map from 'lodash/map'
import size from 'lodash/size'

const Wrapper = styled(Container)`
  & {
    padding: 0;
    max-width: none;
  }
`

const SummaryWrapper = styled(ModalSection)`
  max-width: 420px;
  width: 30%;
  margin-right: ${spacer(4)};
`

const ResultsWrapper = styled(ModalSection)`
  flex: 1;
  padding-right: ${spacer(5)};
  padding-left: ${spacer(4)};
`

const SummaryHeader = styled(Bolder.withComponent(Pewter))`
  margin-bottom: ${spacer(4)};
  text-transform: uppercase;
`

const EditLink = styled(PlainLink)`
  margin-top: ${spacer(4)};
`

const Title = styled(Bold.withComponent('h5'))`
  margin-bottom: ${spacer(4)};
`

class Results extends React.Component {
  state = {
    pendingVendor: ''
  }

  handleSelect = estimateID => {
    const { location } = this.props
    const estimateData = location.state.results[estimateID]
    this.setState({ pendingVendor: estimateData.name })
    postSample({
      estimateUUID: estimateID,
      surveyTitle: sampleName()
    })
      .then(resp => redirectDone(resp.data.uuid))
      .catch(() => this.setState({ pendingVendor: '' }))
  }

  render() {
    const { location, history } = this.props
    const numResults = size(location.state.results)
    return (
      <Wrapper>
        <SummaryWrapper>
          <Container>
            <SummaryHeader>Summary</SummaryHeader>
          </Container>
          <SummaryBox {...location.state.form} />
          <Container>
            <EditLink
              onClick={() =>
                history.push({
                  pathname: '/form',
                  search: location.search,
                  state: {
                    form: location.state.form
                  }
                })
              }
            >
              <Bold>Edit Sample Criteria</Bold>
            </EditLink>
          </Container>
        </SummaryWrapper>
        <ResultsWrapper>
          <Title>
            Your criteria have returned {numResults} result
            {numResults > 1 ? 's' : ''}.
          </Title>
          {numResults // sanity check
            ? map(location.state.results, ({ app, finalPrice }, id) => (
                <Result
                  key={id}
                  estimateID={id}
                  vendor={app}
                  price={finalPrice}
                  completions={location.state.form.completions}
                  disabled={this.state.pendingVendor !== ''}
                  onSelect={this.handleSelect}
                />
              ))
            : null}
        </ResultsWrapper>
      </Wrapper>
    )
  }
}

export default Results



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/results/index.js